if (window.location.pathname === "/inyeccion/periodo" || window.location.pathname === "/zona-trabajo") {

    document.addEventListener('click', function (e) {
        const btnModalFinalizarTurnoInyeccion = e.target.closest('#btnModalFinalizarReporteInyeccion');
        if (!btnModalFinalizarTurnoInyeccion) return;

        const formProduccion = document.querySelector("#formProduccionInyeccion");
        const modalFinalizar = document.querySelector("#modalFinalizarTurnoInyeccion");

        if (!formProduccion || !modalFinalizar) return;

        const inputReporte = formProduccion.querySelector("#idReporteInyeccion");
        const inputIdEncabezado = modalFinalizar.querySelector("#idEncabezadoReporteInyeccion");

        if (!inputReporte || !inputIdEncabezado) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan datos para finalizar el turno.", "alerta-roja");
            }
            return;
        }

        inputIdEncabezado.value = inputReporte.value || "";
    });


    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formFinalizarTurnoInyeccion') return;

        const botonActivo = e.submitter;

        if (!botonActivo || botonActivo.id !== 'btnFinalizarTurnoInyeccion') {
            return;
        }

        e.preventDefault();

        const formulario = e.target;
        const modalProduccionInyeccion = document.querySelector("#modalProduccionInyeccion");
        const modalPadre = formulario.closest('.modal');
        const btnFinalizar = botonActivo;
        const spinner = btnFinalizar.querySelector('#spinner') || formulario.querySelector('#spinner');

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnFinalizar) btnFinalizar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/inyeccion/finalizar-turno-inyeccion', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json = null;

            try {
                json = await respuesta.json();
            } catch (errorJson) {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                console.error('Error HTTP:', respuesta.status, json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Error al finalizar el turno.', 'alerta-roja');
                } else {
                    alert('Error al finalizar el turno.');
                }

                return;
            }

            if (!json || !json.result) {
                console.error('Respuesta inesperada:', json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                }

                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(
                                error.mensaje || 'Error de validación.',
                                error.clase || 'alerta-roja'
                            );
                        }

                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }

                return;
            }

            const idReporteInput = formulario.querySelector('#idEncabezadoReporteInyeccion');
            const idReporte = idReporteInput ? idReporteInput.value : '';

            const params = new URLSearchParams(window.location.search);
            const mes = params.get("mes");
            const anio = params.get("año");

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalProduccionInyeccion) modalProduccionInyeccion.classList.remove('modal--show');

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Turno finalizado con éxito.", "alerta-verde");
            }

            if (typeof window.actualizarModalReporteInyeccion === 'function' && idReporte) {
                window.actualizarModalReporteInyeccion(idReporte);
            }

            if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                window.actualizarTableroInyeccionPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(mes, anio);
            }
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }


        } catch (error) {
            console.error("Error:", error);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Error crítico al procesar la solicitud.", "alerta-roja");
            } else {
                alert("Error crítico al procesar la solicitud.");
            }

        } finally {
            if (btnFinalizar) btnFinalizar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}